<script>
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import { getUserData } from '@/api/FirebaseUserWrapper.js'
import { addHref, formatDate, countCharacters, removeHtml } from '@/api/Utilities.js'
import { updateCardTextAndMarker } from '@/api/FirebaseBoardWrapper.js'
import linkCard from '@/components/LinkNodeCard'
require('@/css/style.css')

export default {
  components: {
    modalWindow,
    linkCard
  },
  props: [
    'card',
    'loginUserId', // Treeを見ているユーザーのID
    'teamId',
    'nodeId',
    'enableEditNode'
  ],
  data () {
    return {
      cardMsg: '',
      selectColor: '',
      cardUserImageUrl: '', // この質問をしたuserの画像URL
      targetUrl: '',
      cardUserData: {},
      Q_LENGTH: 1000,
      editCardMsgLength: 0,
      editCardMsg: '',
      editDoneCardMsg: '',
      alertEditCardMsg: '' // 入力した質問がルール違反の際の警告文章
    }
  },
  async created () {
    await this.createCard()
  },
  computed: {
    rows: function () {
      if (!this.editCardMsg) { return 1 }
      const num = this.editCardMsg.split('\n').length
      return (num < 6) ? num : 6
    }
  },
  watch: {
    card: {
      handler: async function (val) {
        await this.createCard()
      },
      deep: true
    },
    enableEditNode: function (val) {
      if (this.enableEditNode) {
        this.editCardMsg = this.editDoneCardMsg ? this.editDoneCardMsg : removeHtml(this.card.question)
        this.$nextTick(() => this.$refs.CardTextInput.focus())
      }
    },
    editCardMsg: function (val) {
      this.editCardMsgLength = countCharacters(this.editCardMsg)
    }
  },
  methods: {
    async createCard () {
      // 色の設定
      this.selectColor = this.card.marker
      // 編集完了メッセージの初期化
      this.editDoneCardMsg = ''
      // targetURLの計算
      this.targetUrl = this.getUrl(this.card.question)
      // cardMsgで正規表現化
      this.cardMsg = addHref(this.card.question)
      // editCardMsgに初期値入力
      this.editCardMsg = removeHtml(this.card.question)
      // userNameの取得
      this.cardUserData = await getUserData(this.card.userId) || {name: 'unknown user'}
      this.cardUserImageUrl = this.cardUserData.imageUrl
    },
    getUrl: function (message) {
      if (!message) { return }
      let match = message.match('https?://[^\\s|^<]+')
      if (!match) { return }
      return match[0]
    },
    async keyDownCtrlEnter () {
      await this.updateCard()
    },
    cancelEdit () {
      this.$emit('endEditNode')
      this.alertEditCardMsg = ''
    },
    async updateCard () {
      this.alertEditCardMsg = ''
      if (!this.editCardMsg) {
        this.alertEditCardMsg = '文字を入力してください'
        return
      }
      if (this.editCardMsgLength > this.Q_LENGTH) {
        this.alertEditCardMsg = '指定文字数を超えています'
        return
      }
      try {
        await updateCardTextAndMarker(this.teamId, this.card.id, this.editCardMsg, this.selectColor)
        this.cardMsg = addHref(this.editCardMsg)
        this.editDoneCardMsg = removeHtml(this.cardMsg)
        this.$emit('endEditNode')
        this.editCardMsg = ''
      } catch (err) {
        this.alertNextCardMsg = 'error'
        console.error(err)
      }
    },
    replaceSpaceToEnsp (message) {
      // 先頭のspaceのみ&ensp;変換
      // 文章中のspaceを変換してしまうと<a href>が<a&ensp;href>のようになりバグる
      // 1行ずつ文章を分ける
      return message.split('\n').map(text => {
        let sentence = ''
        let flag = false
        for (let i = 0; i < text.length; i++) {
          if (text.charAt(i) === ' ' && !flag) {
            // 先頭文字列がspaceが続く間はspace->enspに変換
            sentence += '&ensp;'
          } else {
            // 先頭から文字列がSpaceでなくなったタイミングでflagを立てる
            flag = true
            sentence += text.charAt(i)
          }
        }
        return sentence
      }).join('\n')
    }
  },
  filters: {
    timestampToDate: function (firebaseTimestamp) {
      if (!firebaseTimestamp || firebaseTimestamp.hasOwnProperty('toDate')) {
        return
      }
      return formatDate(firebaseTimestamp.toDate(), 'MM/dd HH:mm')
    }
  }
}

</script>
<style scoped>
.comments{
  background-color: #fcfcfc;
  border: 1px solid rgba(200, 200, 200, 0.5);
  margin-bottom: 1rem;
}
.media {
  padding: 0px 10px;
}
.media-left {
  margin-right: 0.5rem;
  margin-top: 0.5rem;
}
.has-text-gray {
  color: #A9A9A9 !important;
}
.column {
  padding-top: 0.25rem;
  padding-bottom: 0;
}
.message {
 background-color: #fcfcfc;
 margin-bottom: 0rem;
}
.node-message {
  max-height: 35vh;
  overflow: auto;
}
.edit-message {
  padding-left: 0.75rem;
  padding-bottom: 0.25rem;
  white-space: pre-line;
  word-break: break-all;
}
.progress {
  margin-top: 2px;
  background-color: #dbdbdb;
}
.is-size-8 {
  font-size: 0.5rem !important;
}
.add-paddingright {
  padding-right: 0.75rem;
  padding-bottom: 0.75rem;
}
.ref {
  margin: 0.25rem;
}
</style>
<template>
  <div class="comments">
    <!--Q Windowのarticle-->
    <article class="media">
      <figure class="media-left">
        <router-link v-bind:to="{ path: '/profile/' + card.userId }">
          <p class="image is-32x32">
            <img class="is-rounded" :src="cardUserImageUrl">
          </p>
        </router-link>
      </figure>
      <div class="media-content">
        <div class="content">
          <div class="columns is-multiline is-mobile is-marginless">
            <div class="column is-one-fifth">
              <p class="text has-text-gray has-text-left has-text-weight-bold is-size-8">{{ cardUserData.name }}</p>
            </div>
            <div class="column">
              <!--通常の色-->
              <div class="text is-size-7 has-text-right" v-if="!enableEditNode">
                <div class="control">
                  <div v-if="card.marker === 'thinking'">
                    <span class="text has-text-danger">
                      <i class="fa-solid fa-square"></i>
                    </span>
                  </div>
                  <div v-else-if="card.marker === 'soso'">
                    <span class="text has-text-warning">
                      <i class="fa-solid fa-square"></i>
                    </span>
                  </div>
                  <div v-else>
                    <span class="text has-text-success">
                      <i class="fa-solid fa-square"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!--編集時の色設定-->
              <div class="text is-size-7 has-text-right" v-else>
                <div class="color-switch">
                  <div class="control">
                    <label class="radio">
                      <input type="radio" value="thinking" v-model="selectColor">
                      <span class="text has-text-danger">
                        <i class="fa-solid fa-square"></i>
                      </span>
                    </label>
                    <label class="radio">
                      <input type="radio" value="soso" v-model="selectColor">
                      <span class="text has-text-warning">
                        <i class="fa-solid fa-square"></i>
                      </span>
                    </label>
                    <label class="radio" disabled>
                      <input type="radio" value="important" v-model="selectColor">
                      <span class="text has-text-success">
                        <i class="fa-solid fa-square"></i>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--通常コメント表示-->
          <div v-if="!enableEditNode" class="node-message">
            <div class="edit-message has-text-left">
              <p v-html="replaceSpaceToEnsp(cardMsg)"></p>
            </div>
            <div v-if="targetUrl">
              <linkCard
              :url = "targetUrl"
              />
            </div>
          </div>
          <!--編集時のコメント表示-->
          <div class="message" v-else>
            <div class="field">
              <div class="control has-text-left">
                <textarea v-if="0<editCardMsgLength && editCardMsgLength<=Q_LENGTH"
                class="textarea" ref="CardTextInput" placeholder="メモやメッセージを書く" v-model="editCardMsg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()"></textarea>
                <textarea v-else
                class="textarea is-danger" ref="CardTextInput" placeholder="メモやメッセージを書く" v-model="editCardMsg" :rows="rows" @keydown.ctrl.enter="keyDownCtrlEnter()" @keydown.meta.enter="keyDownCtrlEnter()"></textarea>
              </div>
            </div>
            <div class="state">
              <div class="columns is-mobile is-marginless">
                <div class="column is-one-quarters is-paddingless">
                  <div class="add-paddingleft">
                    <progress class="progress is-small" :value="editCardMsgLength" max="Q_LENGTH"></progress>
                  </div>
                </div>
                <div class="column is-one-quarters is-paddingless is-size-7">
                  残り{{Q_LENGTH-editCardMsgLength}}
                </div>
                <div class="column is-paddingless">
                  <div class="field add-paddingright">
                    <div class="control has-text-right">
                      <button class="button is-small" @click="cancelEdit()">
                        <span>キャンセル</span>
                      </button>
                      <button class="button is-small is-link" @click="updateCard()">
                        <span>保存</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="help is-danger has-text-centered">{{alertEditCardMsg}}</p>
          </div>
          <!-- フッター -->
          <div class="columns is-multiline is-mobile is-marginless">
            <div class="column is-two-fifths">
              <div class="ref has-text-left is-size-7" v-if="card.treeId">
                <router-link v-bind:to="{ path: '/tree/' + card.treeId,  query: { node: card.nodeNumber } }">
                  <span class="tag is-link is-light">クリップ元のTreeへ</span>
                </router-link>
              </div>
            </div>
            <div class="column">
              <div class="text is-size-7 has-text-right">
                <span class="text has-text-gray">
                  <span class="icon is-small">
                    <i class="fa-solid fa-clock" aria-hidden="true"></i>
                  </span>
                  作成：{{this.card.createdAt | timestampToDate}}
                </span>
                <span class="text has-text-gray">
                  <span class="icon is-small">
                    <i class="fa-solid fa-clock" aria-hidden="true"></i>
                  </span>
                  更新：{{this.card.updatedAt | timestampToDate}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>



// WEBPACK FOOTER //
// src/pages/board/showCard.vue